import './related.component.scss'
import { breakpoints } from '../../application/utils/breakpoints'
import { throttle } from '../../application/utils/timings'
import { Swiper, Navigation, Keyboard, Mousewheel } from 'swiper'
Swiper.use(Navigation)
Swiper.use(Keyboard)
Swiper.use(Mousewheel)

document.querySelectorAll('.related').forEach((root) => {
  const swiperElement = root.querySelector('.swiper-container')
  const swiperButtons = root.querySelector('.swiper-buttons')
  const swiperInstance = new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 10,
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    mousewheel: {
      forceToAxis: true
    },
    navigation: {
      prevEl: swiperButtons.querySelector('button[data-prev]'),
      nextEl: swiperButtons.querySelector('button[data-next]')
    },
    breakpoints: {
      [breakpoints.small + 1]: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      [breakpoints.smallest + 1]: {
        slidesPerView: 2
      }
    }
  })
  const arrowHandler = throttle(() => {
    const state =
      swiperInstance.params.slidesPerView >= swiperInstance.slides.length
    swiperButtons.style.display = state ? 'none' : ''
  }, 250)
  window.addEventListener('resize', arrowHandler)
  arrowHandler()
})
